import { Action, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { QuizGameStoreModel } from './quiz-game-store.model';
import { patch } from '@ngxs/store/operators';
import * as actions from './quiz-game.actions';
import { PuzzleGameBaseState } from '../../puzzle-framework-module/puzzle-game-base.state';

@State<QuizGameStoreModel>({
  name: 'quizGameStates',
  defaults: {
    puzzleGames: {},
  },
})
@Injectable()
export class QuizGameState extends PuzzleGameBaseState {
  @Action(actions.InitQuizGame)
  InitQuizGame(state: StateContext<QuizGameStoreModel>, { payload }: actions.InitQuizGame) {
    state.setState(
      patch({
        puzzleGames: patch({ [payload.puzzleID]: payload }),
      })
    );
  }

  @Action(actions.PersistQuizUserInput)
  PersistQuizUserInput(state: StateContext<QuizGameStoreModel>, { payload }: actions.PersistQuizUserInput) {
    state.setState(
      patch({
        puzzleGames: patch({
          [payload.puzzleID]: patch({
            userInput: payload.userInput,
          }),
        }),
      })
    );
  }

  @Action(actions.SetCurrentQuestion)
  SetCurrentQuestion(state: StateContext<QuizGameStoreModel>, { payload }: actions.SetCurrentQuestion) {
    state.setState(
      patch({
        puzzleGames: patch({
          [payload.puzzleID]: patch({
            currentQuestion: payload.currentQuestion,
          }),
        }),
      })
    );
  }
}
